import { SharedAppConstants } from '@tock/shared-app-constants';

interface State {
  tokenizeRequestInProgress: boolean;
}

const initialState = {
  tokenizeRequestInProgress: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type } = action;

  switch (type) {
    case SharedAppConstants.PAYMENT_CARD_TOKENIZE_STARTING:
      return {
        ...state,
        tokenizeRequestInProgress: true,
      };

    case SharedAppConstants.PAYMENT_CARD_TOKENIZE_DONE:
    case SharedAppConstants.PAYMENT_CARD_TOKENIZE_FAILED:
      return {
        ...state,
        tokenizeRequestInProgress: false,
      };

    default: {
      return state;
    }
  }
}
